import React, { useId } from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import './select-input.scss';
import { FormControl, MenuItem, Select, InputLabel } from '@mui/material';
import classNames from 'classnames';

SingleSelectInput.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string
};

export default function SingleSelectInput({ control, options, name, label }) {
  const selectInputId = useId();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=''
      render={({ field }) => (
        <FormControl className={classNames('singleSelectInput', field.value ? 'filled' : '')}>
          <InputLabel>{label}</InputLabel>
          <Select id={selectInputId} value={field.value} placeholder={label} onChange={field.onChange}>
            {options?.map((option, i) => (
              <MenuItem key={i} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    />
  );
}
